/**
 * Parse Query
 * @author Stefano Azzolini <stefano.azzolini@caffeinalab.com>
 */
function parse_query( s ) {
	var j = {},
		res = s.split( /&/gm ).map( function ( e ) {
			var o = e.split( /=/ ),
				pt = j;
			o[0].replace( /^(\w+)\[([^&]+)\]/, '$1][$2' ).split( /\]\[/ ).map( function ( e, i, a ) {
				pt = (
					pt[e] = pt[e] || (
						i == a.length - 1 ? decodeURIComponent( o[1].replace( /\+/, ' ' ) ) : {}
					)
				);
			} );
		} );
	return j;
}

(
	function ( $ ) {

		$( '.esrb-form .all' ).on( 'change', function ( event ) {
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );
			var $all = $fieldgroup.find( 'input[type="checkbox"]:not(.all)' );
			$all.prop( 'checked', false );
		} );

		$( '.esrb-form input[type="checkbox"]:not(.all)' ).on( 'change', function ( event ) {
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );
			var $all = $fieldgroup.find( 'input[type="checkbox"].all' );

			var $checked = $fieldgroup.find( 'input[type="checkbox"]:checked' );
			$all.prop( 'checked', $checked.length == 0 );

		} );

		// Ratings: no tile selected means *all* ratings (same model as platforms), so a click on
		// one tile shows just that rating and further clicks add to it. Selecting every tile is
		// therefore the same query as selecting none - normalise it back to none, so the group
		// has a single "all" state and the next click selects rather than removes. Bound after
		// the handler above, so it has the final say on the `.all` sentinel.
		$( '.esrb-form .ratings input[type="checkbox"]:not(.all)' ).on( 'change', function () {
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );
			var $tiles = $fieldgroup.find( 'input[type="checkbox"]:not(.all)' );

			if ( $tiles.length > 1 && $tiles.filter( ':checked' ).length === $tiles.length ) {
				$tiles.prop( 'checked', false );
				$fieldgroup.find( 'input[type="checkbox"].all' ).prop( 'checked', true );
			}
		} );

		$( '.esrb-form .group h4' ).on( 'click', function ( event ) {
			var $checkboxes = $( this ).closest( '.group' ).find( 'input[type="checkbox"]' );
			var $fieldgroup = $( this ).closest( '.filter-group, .fieldgroup' );

			var $all = $fieldgroup.find( 'input[type="checkbox"].all' );

			var checked = false;

			$checkboxes.each( function ( index, el ) {
				if ( $( el ).prop( 'checked' ) ) {
					checked = true;
				} else {
					checked = false;
					return;
				}
				;
			} );

			if ( !checked ) {
				$checkboxes.prop( 'checked', true );
			} else {
				$checkboxes.prop( 'checked', false );
			}

			var $checked = $fieldgroup.find( 'input[type="checkbox"]:checked' );
			$all.prop( 'checked', $checked.length == 0 );
		} );


		var $searchResultsPlaceholder = $( '.search-results #results' );

		// Initial search on page load
		if ( $searchResultsPlaceholder.html() == '' ) {

			var params = parse_query( window.location.search );

			updateSearchAjax( params.pg );

		}

		var searchTimer;
		var paginationFocusPending = false;
		var xhr = null;
		var cachedResults = {};

		// Abort only when a replacement search is scheduled. On mobile nothing is scheduled (the
		// user applies filters with the Search button), so aborting would strand the spinner.
		$( '.filter input[type=checkbox]' ).change( function ( event ) {
			clearTimeout( searchTimer );

			if ( $( window ).width() > 767 ) {
				if ( xhr ) {
					xhr.abort();
				}
				searchTimer = setTimeout( updateSearchAjax, 2000 );
			}
		} );

		// $( ".filter .esrb-autocomplete" ).on( "autocompleteselect", function( event, ui ) {
		// 	clearTimeout( searchTimer );
		//
		// 	if ( $(window).width() > 767 ) {
		// 		searchTimer = setTimeout( updateSearchAjax, 500 );
		// 	}
		// } );


		// Selects should trigger faster
		$( '.filter select' ).change( function ( event ) {
			clearTimeout( searchTimer );

			if ( $( window ).width() > 767 ) {
				if ( xhr ) {
					xhr.abort();
				}
				searchTimer = setTimeout( updateSearchAjax, 500 );
			}
		} );


		// Honour the OS "reduce motion" setting for the slide, fade and scroll animations here.
		var reduceMotion = !!( window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches );

		function motion( ms ) {
			return reduceMotion ? 0 : ms;
		}

		/**
		 * Move keyboard focus somewhere deliberate after the control that had it disappears
		 * (a removed filter tag, a collapsed panel, a replaced page of results). Without this,
		 * focus falls back to <body> and keyboard / screen-reader users lose their place.
		 */
		function moveFocus( $el ) {
			var el = $el && $el.get( 0 );

			if ( !el ) {
				return;
			}

			if ( !el.hasAttribute( 'tabindex' ) && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test( el.tagName ) ) {
				el.setAttribute( 'tabindex', '-1' );
			}

			try {
				el.focus( { preventScroll: true } );
			} catch ( error ) {
				el.focus();
			}
		}

		function resultsHeading() {
			return $( '.search-results h1' ).first();
		}

		// Polite live region in the template; its strings come from PHP so they are translatable.
		var $status = $( '#search-status' );

		function announce( text ) {
			if ( !$status.length ) {
				return;
			}

			// Clear first, so an identical message (e.g. the same count twice) is re-announced.
			$status.text( '' );
			window.setTimeout( function () {
				$status.text( text );
			}, 100 );
		}

		function announceTotal( total ) {
			var count = parseInt( total, 10 ) || 0;

			if ( 0 === count ) {
				announce( $status.data( 'none' ) || '' );
			} else if ( 1 === count ) {
				announce( $status.data( 'one' ) || '' );
			} else {
				announce( String( $status.data( 'many' ) || '' ).replace( '%s', String( count ) ) );
			}
		}

		// The mobile panel toggle is a real button; its aria-expanded is the single source of
		// truth for both the announced state and the CSS triangle.
		// `done` runs once the slide finishes - callers that need to measure the page
		// afterwards must wait for it, since the panel changes the results' position.
		function toggleRefinePanel( done ) {
			var $toggle = $( '.filter .refine-toggle' );

			$toggle.attr( 'aria-expanded', 'true' === $toggle.attr( 'aria-expanded' ) ? 'false' : 'true' );
			$( '.filter .refine' ).slideToggle( motion( 400 ), done );
		}

		// On mobile the filter panel is stacked above the results, so collapsing it first and
		// scrolling afterwards lands the user on the list. Measuring before the slide finishes
		// would see the results still below the fold and decide there was nothing to do.
		// On desktop the results sit beside the sidebar and are already visible - never scroll.
		function scrollPageToTop() {
			$( 'html, body' ).stop().animate( { scrollTop: 0 }, motion( 500 ), 'swing' );
		}

		function runFilterSearch() {
			if ( $( window ).width() < 768 ) {
				// Collapse first, then go to the top of the page. The filter panel sits above
				// the results on mobile, so after searching from the bottom of a long panel the
				// user would otherwise be left mid-page having to scroll back up. Unconditional
				// here (unlike pagination, which only needs the list start in view).
				toggleRefinePanel( scrollPageToTop );
				// The Search button just collapsed out of view with the panel; follow the page
				// to the top rather than leave focus inside hidden content.
				moveFocus( resultsHeading() );
			}

			updateSearchAjax();
		}

		$( '.filter .button' ).on( 'click', function ( event ) {
			event.preventDefault();
			runFilterSearch();
		} );
		$( '.filter' ).on( 'submit', function ( event ) {
			event.preventDefault();
			runFilterSearch();
		} );

		// Only rendered (display) below md, so no width check is needed.
		$( '.filter .refine-toggle' ).on( 'click', function () {
			toggleRefinePanel();
		} );

		// slideToggle() leaves an inline display on the panel, which outranks the stylesheet: a
		// panel collapsed on mobile stayed hidden after widening past md (e.g. rotating a tablet).
		// On every breakpoint crossing, hand the panel back to CSS - always shown on desktop,
		// collapsed on mobile - and keep the toggle's announced state in step.
		if ( window.matchMedia ) {
			var mobileQuery = window.matchMedia( '(max-width: 767.98px)' );
			var resetRefinePanel = function () {
				$( '.filter .refine' ).stop( true, true ).css( 'display', '' );
				$( '.filter .refine-toggle' ).attr( 'aria-expanded', 'false' );
			};

			if ( mobileQuery.addEventListener ) {
				mobileQuery.addEventListener( 'change', resetRefinePanel );
			} else if ( mobileQuery.addListener ) {
				mobileQuery.addListener( resetRefinePanel );
			}
		}

		var FILTER_GROUPS = {
			platform: '.platforms',
			rating: '.ratings',
			descriptor: '.descriptors',
			ielement: '.ielements'
		};

		/**
		 * Tidy the tag bar after an optimistic removal: drop any group label whose tags have
		 * all gone, and clear the bar entirely once nothing is left (`:empty` then hides it).
		 * Labels and tags are flat siblings, so a label is dangling when the element after it
		 * is no longer a tag.
		 */
		function pruneFilterTags() {
			var $bar = $( '.filter-tags' );

			$bar.find( '.filter-tags__label' ).each( function () {
				var $next = $( this ).next();

				if ( !$next.length || !$next.hasClass( 'filter-tag' ) ) {
					$( this ).remove();
				}
			} );

			if ( !$bar.find( '.filter-tag' ).length ) {
				$bar.empty();
			}
		}

		// Delegated: the tag bar is replaced wholesale on every update.
		$( document ).on( 'click', '.filter-tags .filter-tag', function ( event ) {
			event.preventDefault();

			var $tag = $( this );
			var filter = $tag.data( 'filter' );
			var value = String( $tag.data( 'value' ) );

			if ( 'keyword' === filter ) {
				$( '#searchKeyword' ).val( '' );
			} else if ( FILTER_GROUPS[filter] ) {
				$( '.filter ' + FILTER_GROUPS[filter] ).find( 'input[type="checkbox"]' ).filter( function () {
					return this.value === value;
					// `change` keeps the hidden `.all` sentinel in sync.
				} ).prop( 'checked', false ).trigger( 'change' );
			}

			// Where focus goes once this tag is gone: the next tag, else the previous one.
			var $tags = $( '.filter-tags .filter-tag' );
			var index = $tags.index( $tag );
			var $neighbour = $tags.eq( index + 1 ).length ? $tags.eq( index + 1 ) : ( index > 0 ? $tags.eq( index - 1 ) : $() );

			// Remove it now instead of waiting on the request; the server-rendered bar that
			// arrives with the response is authoritative and produces the same result.
			$tag.remove();
			pruneFilterTags();

			moveFocus( $neighbour.length && $.contains( document, $neighbour.get( 0 ) ) ? $neighbour : resultsHeading() );

			// The `change` triggered above also armed the checkbox's 2s debounced search. We search
			// right now instead, so cancel it - otherwise it fired mid-request, aborted this search
			// and started it over (two runs per removal, and a slower result on a slow API).
			clearTimeout( searchTimer );
			updateSearchAjax();
		} );

		$( document ).on( 'click', '.filter-tags__reset', function ( event ) {
			event.preventDefault();

			$( '#searchKeyword' ).val( '' );
			$( '.filter input[type="checkbox"]:not(.all)' ).prop( 'checked', false );
			$( '.filter input[type="checkbox"].all' ).prop( 'checked', true );

			// Clear immediately — waiting for the response makes this feel broken.
			$( '.filter-tags' ).empty();
			// The button itself just went with the bar.
			moveFocus( resultsHeading() );

			updateSearchAjax();
		} );

		/**
		 * Bring the start of the results list into view, but only when it is actually off
		 * screen. Scrolling a list the user can already see just moves the page under them,
		 * which is what made filter changes feel broken: tick a box, keep reading, and the
		 * page jumps to the top a couple of seconds later.
		 *
		 * Targets the top of #results rather than the document, so the nav and heading stay
		 * where they are.
		 */
		function scrollResultsIntoView() {
			var $results = $( '.search-results #results' );

			if ( !$results.length ) {
				return;
			}

			var target = $results.offset().top - 20;

			// Start of the list is already at or below the top of the viewport - leave it be.
			if ( $( window ).scrollTop() <= target ) {
				return;
			}

			$( 'html, body' ).stop().animate( { scrollTop: target }, motion( 500 ), 'swing' );
		}

		function updateSearchAjax( page = 1, scroll = false ) {
			var args = {};

			// Only a page change (the one caller passing scroll) moves focus to the new list; any
			// other search clears a flag left behind by a superseded page request.
			paginationFocusPending = !!scroll;

			if ( scroll ) {
				scrollResultsIntoView();
			}

			args.searchKeyword = $( '#searchKeyword' ).val();
			args.searchType = $( '#searchType' ).val();
			if ( $( '#timeFrame' ).length ) {
				args.timeFrame = $( '#timeFrame' ).val();
			}

			args.pg = page;
			args.platform = [];
			args.rating = [];
			args.descriptor = [];
			args.ielement = [];

			$( '.filter .platforms input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.platform.push( $( this ).val() );
			} );
			$( '.filter .ratings input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.rating.push( $( this ).val() );
			} );
			$( '.filter .descriptors input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.descriptor.push( $( this ).val() );
			} );

			$( '.filter .ielements input[type="checkbox"]:checked' ).each( function ( index, elem ) {
				args.ielement.push( $( this ).val() );
			} );

			if ( xhr ) {
				xhr.abort();
			}
			const stringifiedArgs = queryString.stringify( args );

			$searchResultsPlaceholder.attr( 'aria-busy', 'true' );

			$searchResultsPlaceholder.fadeOut( motion( 300 ), function () {

				$searchResultsPlaceholder.html( '<div class="spinner-cont"><div class="loading-spinner"></div></div>' ).fadeIn( motion( 400 ) );

				if ( cachedResults[stringifiedArgs] ) {

					ajaxPutUpdatedContent( cachedResults[stringifiedArgs] );

				} else {

					xhr = $.ajax( {
						url: ESRB.ajaxurl,
						type: 'post',
						dataType: 'json',
						data: {
							action: 'search_rating',
							args: args
						},
					} ).done( function ( response ) {
						console.info( (
							response.json_body || ''
						) );

						cachedResults[stringifiedArgs] = response;
						/* double cache because URL params may change after being received from PHP back via ajax */
						cachedResults[queryString.stringify( response.args )] = response;
						ajaxPutUpdatedContent( response );
					} ).fail( function ( jqXHR, textStatus ) {
						// Superseded by a newer search (only aborted when one is scheduled) - it renders.
						if ( 'abort' === textStatus ) {
							return;
						}

						// Previously the spinner stayed up forever (and aria-busy with it).
						var message = $status.data( 'error' ) || '';

						paginationFocusPending = false;
						$searchResultsPlaceholder.attr( 'aria-busy', 'false' )
							.empty()
							.append( $( '<p class="search-error"></p>' ).text( message ) );
						announce( message );
					} );
				}


			} );

		}

		function ajaxPutUpdatedContent( response ) {

			$searchResultsPlaceholder.html( response.html_results );
			$searchResultsPlaceholder.append( response.paging );
			$searchResultsPlaceholder.attr( 'aria-busy', 'false' );
			announceTotal( response.total );
			$( '.search-results .key' ).html( response.args.searchKeyword );

			// Markup comes from esrb_get_filter_tags_html() so the labels are built in exactly
			// one place; the first paint is server-rendered, this only handles later updates.
			// Replacing it destroys whichever tag had focus, so remember it and restore focus to
			// its replacement (or the first tag, or the heading if the bar is now empty).
			var $bar = $( '.filter-tags' );
			var active = document.activeElement;
			var hadFocus = !!( active && $.contains( $bar.get( 0 ) || document.createElement( 'div' ), active ) );
			var focusKey = hadFocus ? {
				reset: $( active ).hasClass( 'filter-tags__reset' ),
				filter: $( active ).data( 'filter' ),
				value: String( $( active ).data( 'value' ) )
			} : null;

			$bar.html( response.filter_tags || '' );

			if ( focusKey ) {
				var $same = focusKey.reset ? $bar.find( '.filter-tags__reset' ) : $bar.find( '.filter-tag' ).filter( function () {
					return $( this ).data( 'filter' ) === focusKey.filter && String( $( this ).data( 'value' ) ) === focusKey.value;
				} );

				moveFocus( $same.length ? $same.first() : ( $bar.find( '.filter-tag' ).length ? $bar.find( '.filter-tag' ).first() : resultsHeading() ) );
			}

			setUrlState( response.args );

			// Pagination: the link that had focus was replaced along with the list.
			if ( paginationFocusPending ) {
				paginationFocusPending = false;
				moveFocus( $searchResultsPlaceholder );
			}
		}


		function setUrlState( args ) {
			var query = queryString.stringify( args, {sort: false, arrayFormat: 'bracket'} );

			if ( history.pushState ) {
				var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + query;
				window.history.pushState( {path: newurl}, '', newurl );
			}
		}

		$( '.search-results #results' ).on( 'click', '.paginate a', function ( event ) {
			event.preventDefault();
			var hash = $( this ).attr( 'href' ).split( '#' )[1] || 0;
			if ( !hash ) {
				hash = 1;
			}
			updateSearchAjax( hash, true );
		} );

	}
)( jQuery );